import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router'
import { Link } from 'react-router-dom';
import Layout from '../../components/layout/Layout'
import { columns, paginationOptions } from '../../directories/collections';
import { getProgressStudent } from '../../helpers/consultas';

const ProgresoAsignaturaView = () => {
    const {email} = useSelector(state => state.perfil)
    const {asig,idAsig} = useParams();
    const [progreso, setProgreso] = useState();
    useEffect(() => {
        getProgressStudent(email,idAsig)
        .then(data => {
            setProgreso(data)
        })

        return () => { }
    }, [ email,idAsig ])

    return (
        <Layout>
            <h1 className='title'>{asig}</h1>
            <div className='controls-return'>
                <Link 
                    to={`/asignatura/${idAsig}`}
                    className='fas fa-arrow-circle-left'
                    > Regresar</Link>
            </div>
            <DataTable
                className='tb-data-table'
                fixedHeader
                columns={columns}
                data={progreso}
                pagination
                paginationComponentOptions={paginationOptions}
            />
        </Layout>
    )
}

export default ProgresoAsignaturaView
